// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__2TE5B","btn-back":"index_btn-back__2Pnpd","title":"index_title__2Uj_Q","form":"index_form__2v3vh"};